export interface ApiTeamPosition {
  uuid: string;
  name: string;
  is_custom: boolean;
}

export class TeamPosition {
  uuid: string;
  name: string;
  is_custom: boolean;
  // Minimal registry of uuid -> name per team (reverse lookup only)
  private static uuidToNameByTeam: Map<string, Map<string, string>> = new Map();
  // Complementary registry of name -> uuid per team (forward lookup for saving)
  private static nameToUuidByTeam: Map<string, Map<string, string>> = new Map();

  constructor(data: ApiTeamPosition) {
    this.uuid = data.uuid;
    this.name = data.name;
    this.is_custom = data.is_custom;
  }

  /** Register a team's positions (uuid -> name only) */
  static register(teamTwrn: string, positions: (ApiTeamPosition | TeamPosition)[]): void {
    const byUuid = new Map<string, string>();
    const byName = new Map<string, string>();
    positions.forEach((pos) => {
      const instance = pos instanceof TeamPosition ? pos : new TeamPosition(pos);
      byUuid.set(instance.uuid, instance.name);
      byName.set(instance.name, instance.uuid);
    });
    this.uuidToNameByTeam.set(teamTwrn, byUuid);
    this.nameToUuidByTeam.set(teamTwrn, byName);
  }

  /** Resolve a position name from a uuid for a given team */
  static resolveName(teamTwrn: string, uuid?: string | null): string | null {
    if (!uuid) return null;
    const byUuid = this.uuidToNameByTeam.get(teamTwrn);
    if (!byUuid) return null;
    return byUuid.get(uuid) ?? null;
  }

  /** Resolve a position uuid from a name for a given team */
  static resolveUuid(teamTwrn: string, name?: string | null): string | null {
    if (!name) return null;
    const byName = this.nameToUuidByTeam.get(teamTwrn);
    if (!byName) return null;
    return byName.get(name) ?? null;
  }
}
